class RouteProgressModel extends App.Models.Route {
    modelUrl = 'RouteProgress';
}

App.Models.RouteProgress = RouteProgressModel;
